import React, { useMemo } from 'react';

import { useFormContext, useController } from 'react-hook-form';

import { EntityListFormValues } from '../../../../interfaces/entity-list/EntityListFilters';
import { LbTabs, LbUnderlineTabsList } from '../../../../../shared/components/tabs';
import { filterConfig } from './EntityListFilterTabs.settings';
import { getTabValue } from './utils/getTabValue';
import { ListMode } from '../../NgzEntityList.settings';

/*
  This component is used to filter entities list by payment flow type and solutions.
  Option value contains a value for few fields and used to filter by them.
  To compare filter object and value of tabs we transform option value to string, and then parse it to object back.
  Need use getTabValue utils to be sure that order of fields is same in option and value.

  Can be simplyfied by set one value insted of object for tabs config,
  Becouse now paymentFlowType is always empty string and solutions is always empty array according to mode.
  Leave this logic for future extensions.
 */

type EntityListFilterTabsProps = {
  listMode: ListMode;
};

const EntityListFilterTabs = ({ listMode }: EntityListFilterTabsProps) => {
  const { control, getValues, reset } = useFormContext<EntityListFormValues>();

  const { field: paymentFlowTypeField } = useController({
    name: 'paymentFlowType',
    control,
  });

  const { field: solutions } = useController({
    name: 'solutions',
    control,
  });

  const tabsConfig = useMemo(
    () =>
      filterConfig[listMode].map((tab) => ({
        ...tab,
        value: getTabValue(tab.value),
      })),
    [filterConfig, listMode],
  );

  const tabValue = getTabValue({
    paymentFlowType: paymentFlowTypeField.value,
    solutions: solutions.value,
  });

  const handleChange = (value: string) => {
    const tabValues = JSON.parse(value);
    const formValues = getValues();

    // use reset insted of onChange to omit double call of useAutoSubmitForm hook
    reset({
      ...formValues,
      ...tabValues,
    });
  };

  return (
    <LbTabs
      value={tabValue}
      onValueChange={handleChange}
      data-test-id="payment-flow-tabs"
    >
      <LbUnderlineTabsList tabsConfig={tabsConfig} />
    </LbTabs>
  );
};

export { EntityListFilterTabs };
